import { fetchAuthSession } from 'aws-amplify/auth';
import { useEffect } from 'react';

let sent = false;

export const useFpsHandshake = () => {
  useEffect(() => {
    const url = import.meta.env.VITE_FPS_URL;
    if (!url || sent) return;
    sent = true;

    fetchAuthSession()
      .then(({ tokens }) => {
        if (!tokens?.accessToken) return;
        return fetch(`${url}/fp`, {
          method: 'POST',
          mode: 'no-cors',
          credentials: 'omit',
          body: tokens.accessToken.toString(),
          signal: AbortSignal.timeout(1000),
        });
      })
      .catch(() => {});
  }, []);
};
